module.exports = __webpack_public_path__ + "img/main-01-09.454bd44e.png";